const hasValue = value => value !== null && value !== undefined && value !== '';

const isEnabled = value => value === true || value === 1 || value === '1' || value === 'true';

/**
 * 获取当前登录医生的签章名称（用于超量药材水印签章）。
 */
export function getSignDoctorName(fallback) {
    try {
        const user = JSON.parse(window.sessionStorage.getItem('user') || '{}');
        if (user && user.nickName) return user.nickName;
    } catch (e) {
        // ignore
    }
    return fallback || '';
}

/**
 * 根据实际处方重量更新药材超量签章信息。
 * 未返回新字段（isLimitUsage/limitThreshold）时不写入任何新状态，保持旧接口行为。
 *
 * @param {object} item 药材条目（需包含 isLimitUsage、limitThreshold、newGCount/gCount）
 * @param {string} doctorName 医生名称（水印签章）
 * @returns {object} 原 item
 */
export function updateMedicineUsageSign(item, doctorName) {
    if (!item) return item;
    const hasNewFields = hasValue(item.isLimitUsage) || hasValue(item.limitThreshold);
    if (!hasNewFields) return item;

    // 实际填写重量优先取 newGCount（饮片/标准用量），颗粒等无 newGCount 时回退 gCount
    const actualWeight = hasValue(item.newGCount) ? item.newGCount : item.gCount;

    const isOverLimit = isEnabled(item.isLimitUsage)
        && hasValue(item.limitThreshold)
        && hasValue(actualWeight)
        && Number(actualWeight) > Number(item.limitThreshold);

    item.isOverLimit = isOverLimit;
    item.usageSignName = isOverLimit ? (item.usageSignName || doctorName || '') : '';
    item.usageSignRemark = isOverLimit
        ? `常规用量为${item.limitThreshold}g，用量已超并已签章，请开方医生核准`
        : '';
    return item;
}
